import { CodeValue } from "./CodeValue";
import { DatePeriodModel } from "./DatePeriodModel";
import { RecordMetadata } from "./RecordMetadata";

class ConditionModel {
    public Metadata: RecordMetadata | null = null;
    public Id: number;
    public PatientId: number;
    public LocationId: number;
    public Reason: CodeValue = new CodeValue();
    public ReasonDetails: string = "";
    public Category: CodeValue = new CodeValue();
    public DatePeriod: DatePeriodModel = new DatePeriodModel();
    public Evidence: CodeValue[] = [];
    public Agent: CodeValue = new CodeValue();
    public Antigen: CodeValue = new CodeValue();
    public Notes: string = "";

    constructor(init?: Partial<ConditionModel>) {
        Object.assign(this, init);
        this.DatePeriod = new DatePeriodModel({ ...init?.DatePeriod });
    }

    public static Clone(model: ConditionModel): ConditionModel {
        return JSON.parse(JSON.stringify(model));
    }
}

export { ConditionModel };
